import _ from 'underscore';
import utils = require('../utils');

export class ArithmeticOperator {
    public static operator(operator: string): (a: any, b: any) => number|undefined {
        /* tslint:disable:triple-equals */
        if(operator === "+") { return (a, b) => a + b }
        if(operator === "-") { return (a, b) => a - b }
        if(operator === "*") { return (a, b) => a * b }
        if(operator === "/") { return (a, b) => b === 0 ? undefined : (a / b) } // consider use NaN
        if(operator === "div") { return (a, b) => b === 0 ? undefined : Math.floor(a / b); } // consider use NaN

        return (a, b) => undefined;
        /* tslint:enable:triple-equals */
    }

    public static undefinedSafe(operator: string) {
        return (a: any, b: any): number|undefined => (_.isUndefined(a) || _.isUndefined(b)) ? undefined : ArithmeticOperator.operator(operator)(a, b);
    }

    public static numericSafe(operator: string) {
        return (a: any, b: any): number|undefined => {
            return ArithmeticOperator.undefinedSafe(operator)(utils.anyToNumeric(a), utils.anyToNumeric(b));
        }
    }

    public static describe(operator: string): string {
        switch(operator) {
            case '+': return '+';
            case '-': return '-';
            case '*': return '*';
            case '/': return '/';
            case 'div': return 'div';
            default: return '==';
        }
    }

}